import {
  IFoundationIconProps,
  BuilderFoundationIcon,
} from "@faire/builder-core/registerBuilderComponents/__internal__/BuilderFoundationIcon";
import {
  Avatar,
  AvatarIconPosition,
  AvatarSize,
} from "@faire/slate/components/avatar";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import React from "react";

interface IBuilderAvatarProps {
  borderColor?: string;
  label?: string;
  image?: IImage;
  size?: ResponsiveProp<AvatarSize>;
  icon?: IBuilderAvatarIconProps;
}

interface IBuilderAvatarIconProps extends IFoundationIconProps {
  position?: AvatarIconPosition;
  showContainer?: boolean;
}

export const BuilderAvatar = ({
  borderColor,
  label,
  image,
  size,
  icon,
}: IBuilderAvatarProps) => {
  return (
    <Avatar
      borderColor={borderColor}
      label={label}
      image={image}
      size={size}
      iconProps={{
        Component: () =>
          icon?.iconName
            ? BuilderFoundationIcon({
                ...icon,
                width: "100%",
                height: "100%",
              })
            : null,
        position: icon?.position,
        showContainer: icon?.showContainer,
      }}
    />
  );
};
